import { faMoneyBill1 } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PiCircleBold } from "react-icons/pi";

export default function WebinarCourseFee() {
  return (
    <section className="my-20">
      <p className="text-xl my-10">রেজিস্ট্রেশন ফীঃ</p>
      <div className="grid grid-cols-1 md:grid-cols-4">
        <div className="relative overflow-hidden md:order-2 w-56 h-28 rounded py-2 px-5 mx-auto my-3 md:my-0 bg-gradient-to-tl from-green-300 to-green-100 payment-card">
          <div className="flex justify-between">
            <div className="mr-10">
              <p>মাত্র</p>
            </div>
            <FontAwesomeIcon
              className={`text-2xl text-green-600 `}
              icon={faMoneyBill1}
            />
          </div>
          <PiCircleBold className="text-8xl absolute -ml-14 mt-2  opacity-10 text-inherit" />

          <p className={`text-center font-bold text-xl my-2 text-green-600 `}>
            <span className="font-bold text-xl">৳ ২০০</span>
          </p>
        </div>
      </div>
    </section>
  );
}
